export default __webpack_public_path__ + "static/media/38.4128c3f2.jpg";